import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getMonthlyOrderById } from "../../apis/order";
import { IGetMonthlyOrderResponse } from "../../apis/order/type";
import BookingDetailBlock from "../../components/molecules/bookingDetailBlock";
import GoHomeButton from "../../components/molecules/goHomeButton";
import { toHK } from "../../helper/format";
import { ROUTE_PATHS } from "../../routes/paths/route-paths";
import useInfoStateStore from "../../store/infoState";

const PaymentResult: React.FC = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("orderId");
  const resultCode = searchParams.get("resultCode");
  const navigate = useNavigate();
  const [order, setOrder] = useState<
    IGetMonthlyOrderResponse | null | undefined
  >(undefined);

  const clearInfoState = useInfoStateStore((state) => state.clearInfoState);

  const fetchOrderDetails = async (orderId: string) => {
    try {
      setOrder(null);
      const orderResult = await getMonthlyOrderById(+orderId);

      if (orderResult.id) {
        setOrder(orderResult);
      }
    } catch (error) {
      setOrder(undefined);
    }
  };

  useEffect(() => {
    clearInfoState();
    // const loginState = JSON.parse(localStorage.getItem("wbloginState") || "{}");
    if (orderId) {
      fetchOrderDetails(orderId);
    } else {
      navigate(ROUTE_PATHS.LANDING_PAGE);
    }
  }, [orderId]);

  const formattedExtraCarPlateDetails = order?.extraCarPlates.map((item) => ({
    carplate: item.sub_car_plate,
    octopusNumber: item.octopus_number,
  }));

  return (
    <div className="flex flex-1 flex-col gap-4">
      <span className="text-2xl font-bold text-white mt-10">
        <span
          className={
            resultCode === null || resultCode == "authorised"
              ? "text-mainYellow"
              : "text-red-500"
          }
        >
          {resultCode === null || resultCode === "authorised"
            ? "  已成功訂閱！"
            : "未能成功訂閱！"}
        </span>
        請查看您的電郵。
      </span>

      {resultCode !== null && resultCode !== "authorised" && (
        <span className="text-sm">
          付款失敗，請登入帳戶並於15分鐘內重新付款或聯絡我們的客服團隊。
        </span>
      )}

      {order === null && (
        <div className="flex flex-col justify-center skeleton h-60 w-full p-4"></div>
      )}

      {order && (
        <BookingDetailBlock
          name={order?.u_name}
          carPlate={order?.u_lpn}
          phone={order?.u_tel}
          email={order?.u_email}
          parkingName={order.parking.display_name}
          parkingAddress={order.parking.location}
          startDate={toHK(order.start_date).format("YYYY-MM-DD")}
          octopusNumber={order?.octopus_number}
          itemTypeID={order.monthlyOrderItem.item_type_id}
          itemName={order.monthlyOrderItem?.display_name}
          interval_count={order.monthlyOrderItem?.interval_count}
          price={order.monthlyOrderItem?.price}
          extra_car_plate_price={order.monthlyOrderItem?.extra_car_plate_price}
          extraCarPlateDetails={formattedExtraCarPlateDetails}
        />
      )}

      <GoHomeButton />
    </div>
  );
};

export default PaymentResult;
